import { RichText } from "components/RichTextWidget";
import { Container, Heading2, Heading6, ImageLite } from "shared/components";

import styles from "./Hero033.module.scss";

export const Hero033 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const subtitle = payload?.subtitle ?? "";
  const description = payload?.description ?? "";
  const image = payload?.image ?? {};

  return (
    <div className={styles.wrapper}>
      <Container>
        <Heading2 className={styles.headline} color="dark">
          {headline}
        </Heading2>
        <div className={styles.content}>
          <Heading6 className={styles.subtitle} color="dark">
            {subtitle}
          </Heading6>
          <RichText
            value={description}
            className={styles.description}
            color="dark"
          />
        </div>
        <ImageLite image={image} className={styles.image} />
      </Container>
    </div>
  );
};

export default Hero033;
